/* eslint-disable */
import { FILTER_PROJECT_SELECTED } from '../Filters.types';

/**
 * Action to select the project in the filters
 * @param {string} project The project
 * @returns {ActionCreator<FromPayload<Array<string>, ActionMeta, FILTER_PROJECT_SELECTED>>} The created `Action`
 */
const filtersSelectProject = (project) => ({ fromPayload }) => {
  return fromPayload(project, {}, FILTER_PROJECT_SELECTED);
};

export default filtersSelectProject;
